import {Component, OnInit} from '@angular/core';
import {AppCodeViewComponent} from "../../../../components/code-view/code-view.component";
import {HasAuthDirective} from "../../../../../core/authorization/has-auth.directive";
import {LocalizationPipe} from "../../../../pipe/localization-pipe";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from "@angular/material/table";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {TablerIconsModule} from "angular-tabler-icons";
import {AuthorizationService} from "../../../../../core/authorization/AuthorizationService";
import {AuthInfoDTO} from "../../../../../core/dto/AuthInfoDTO";
import {MatDialog} from "@angular/material/dialog";
import {RoleService} from "../../../../services/apps/role/role.service";
import {
  RoleManagementListDialogComponent
} from "../role-management/role-management-list-dialog/role-management-list-dialog.component";

@Component({
  selector: 'app-system-role-management',
  imports: [
    AppCodeViewComponent,
    HasAuthDirective,
    LocalizationPipe,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIconButton,
    MatRow,
    MatRowDef,
    MatTable,
    MatTooltip,
    TablerIconsModule,
    MatHeaderCellDef
  ],
  templateUrl: './system-role-management.component.html',
  styleUrl: './system-role-management.component.scss'
})
export class SystemRoleManagementComponent implements OnInit {

  activeUser: AuthInfoDTO;
  dataSource: MatTableDataSource<SystemRole[]> = new MatTableDataSource<SystemRole[]>()
  displayedColumns: string[] = ['name', 'createdDate', 'updatedDate', 'detail'];
  systemRoles: SystemRole[];

  constructor(private authorizationService: AuthorizationService, private dialog: MatDialog, private roleService: RoleService) {}

  ngOnInit(): void {
    this.activeUser = this.authorizationService.getActiveUser();
    this.getSystemRoles();
  }

  getSystemRoles() {
    this.roleService.getSystemRoles().subscribe({
      next: (res: any) => {
        this.dataSource = res.data.content;
        // console.log("Data source for system roles : ",this.dataSource)
      },
      error: err => {
        this.systemRoles = null;
      }
    })
  }

  openAuthorizationCodesDialog(roleId: number, roleName: string) {
    this.dialog.open(RoleManagementListDialogComponent, {
      width: '80vw',
      height: '80vh',
      maxWidth: 'none',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: {
        roleId: roleId,
        roleName: roleName,
      }
    })
  }
}

export interface SystemRole {
  id: number;
  name: string;
  isActive: string;
  createdDate: string;
  updatedDate: string;
}
